import { Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable, Type } from "@angular/core";

export interface OverlayAttachment<T> {
  dispose: () => void;
  componentInstance: T;
}

@Injectable()
export class Overlay2Service {
  private overlayRefs: OverlayRef[] = [];

  constructor(private overlay: Overlay) {}

  createOverlayRef(customConfig?: OverlayConfig): OverlayRef {
    const overlayRef = this.overlay.create(this.getOverlayConfig(customConfig));
    this.overlayRefs.push(overlayRef);
    return overlayRef;
  }

  attachComponent<T>(
    componentType: Type<T>,
    overlayRef: OverlayRef = this.createOverlayRef()
  ): OverlayAttachment<T> {
    const componentPortal = new ComponentPortal(componentType);
    const componentRef = overlayRef.attach(componentPortal);
    let hasDestroyed = false;

    return {
      componentInstance: componentRef.instance,
      dispose: () => {
        if (hasDestroyed) {
          throw new Error("overlayRef already disposed");
        }

        hasDestroyed = true;
        overlayRef.dispose();
        this.overlayRefs = this.overlayRefs.filter((ref) => ref !== overlayRef);
      }
    };
  }

  destroy(): void {
    this.overlayRefs.forEach((ref) => ref.dispose());
    this.overlayRefs = [];
  }

  private getDefaultOverlayConfig(): OverlayConfig {
    return new OverlayConfig();
  }

  private getOverlayConfig(customConfig?: OverlayConfig): OverlayConfig {
    if (!customConfig) {
      return this.getDefaultOverlayConfig();
    }

    return new OverlayConfig(customConfig);
  }
}
